import {
    convertUniversalDateTimeToPersianDateTime,
    RaikoBaseCardContainer,
    RaikoDatePicker,
    RaikoGridOneColumn,
    RaikoGridThreeColumn, RaikoGridTwoColumn,
    RaikoMaterialOutlinedInput,
    RaikoMoneyInputOutlined,
    RaikoNumberInputOutlined,
    RaikoSectionContainer, RaikoToggleOutlined,
    showErrorMessage, RaikoCreatorInfo, RaikoSimpleMultiLineInputOutlined, showWarningMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import {useParams} from "react-router-dom";
import {FundService} from "../../../serverService/fund/FundService";
import {useEffect, useState} from "react";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";
import {detectServerErrorMessage} from "../../../util/detectServerErrorMessage";
import {numberIsNotBiggerThanZero, stringIsEmpty} from "../../../util/VariableChecker";

export default function FundDetailBasicInfo() {

    const {id: fundId = -1} = useParams()
    const service = new FundService()

    const loading = new LoadingHelper(useLoadingDispatcher())

    const [info, setInfo] = useState({
        id: "",

        activityStartDate: "",
        dateOfMeetingPerMonth: "",
        enabled: "",
        fixedFeeRate: "",
        maximumGroupNumber: "",
        minimumAmountReceivedPerMonth: "",
        name: "",
        postalAddress: "",
        theLastDayAllowedToReceiveSavingsPerMonth: "",

        manager: "",

        paymentMerchant: "",

        createdBy: "",
        createdAt: ""
    })


    useEffect(() => {
        getFundBasicInfo()
    }, []);

    function getFundBasicInfo() {
        loading.show()
        service.getFundDetail(fundId)
            .then(response => {
                setInfo({
                    ...response,
                    createdAt: convertUniversalDateTimeToPersianDateTime(response.createdAt),
                    activityStartDate: convertUniversalDateTimeToPersianDateTime(response.activityStartDate)
                })
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            loading.hide()
        })

    }

    function handleUpdateInfo() {
        if (checkFields()) {
            loading.show()
            service.updateFundInfo(
                fundId,
                info
            ).then(response => {
                showSuccessMessage("اطلاعات صندوق با موفقیت بروزرسانی شد.")
            }).catch(reason => {
                showErrorMessage(detectServerErrorMessage(reason))
            }).finally(_ => {
                loading.hide()
            })
        }
    }

    function checkFields() {
        let state = false
        let message = ""

        if (stringIsEmpty(info.name))
            message = "لطفا نام صندوق را وارد نمایید."
        else if (numberIsNotBiggerThanZero(info.maximumGroupNumber))
            message = "لطفا حداکثر تعداد گروه را وارد نمایید."
        else if (numberIsNotBiggerThanZero(info.dateOfMeetingPerMonth))
            message = "لطفا تاریخ روز جلسات ماهانه را وارد نمایید."
        else if (numberIsNotBiggerThanZero(info.fixedFeeRate))
            message = "لطفا حداکثر نرخ کارمزد ثابت را وارد نمایید."
        else if (stringIsEmpty(info.activityStartDate))
            message = "لطفا تاریخ شروع فعالیت را وارد نمایید."
        else if (numberIsNotBiggerThanZero(info.minimumAmountReceivedPerMonth))
            message = "لطفا حداقل مبلغ واریز پس انداز را وارد نمایید."
        else if (numberIsNotBiggerThanZero(info.theLastDayAllowedToReceiveSavingsPerMonth))
            message = "لطفا تاریخ آخرین روز مجاز واریز را وارد نمایید."
        else
            state = true


        if (message)
            showWarningMessage(message)

        return state
    }

    return (
        <RaikoGridOneColumn>
            <RaikoBaseCardContainer>
                <RaikoSectionContainer
                    title={"اطلاعات پایه"}
                    actionButtonOnclick={handleUpdateInfo}
                    actionButtonTitle={"بروزرسانی"}
                    hasActionButton
                >
                    <RaikoGridOneColumn>
                        <RaikoGridThreeColumn>
                            <RaikoMaterialOutlinedInput
                                labelText={"شناسه صندوق"}
                                value={info.id}
                                setValue={value => {
                                }}
                                disabled
                            />
                            <RaikoMaterialOutlinedInput
                                labelText={"نام صندوق"}
                                value={info.name}
                                setValue={value => {
                                    setInfo(prev => {
                                        return {
                                            ...prev,
                                            name: value
                                        }
                                    })
                                }}/>
                            <RaikoNumberInputOutlined
                                labelText={"حداکثر تعداد گروه"}
                                value={info.maximumGroupNumber}
                                setValue={value => {
                                    setInfo(prev => {
                                        return {
                                            ...prev,
                                            maximumGroupNumber: value
                                        }
                                    })
                                }}
                            />
                            <RaikoNumberInputOutlined
                                labelText={"تاریخ روز جلسات ماهانه"}
                                value={info.dateOfMeetingPerMonth}
                                setValue={value => {
                                    if (!value || parseInt(value) < 32) {
                                        setInfo(prev => {
                                            return {
                                                ...prev,
                                                dateOfMeetingPerMonth: value
                                            }
                                        })
                                    }
                                }}/>
                            <RaikoNumberInputOutlined
                                labelText={"نرخ کارمزد ثابت (درصد)"}
                                value={info.fixedFeeRate}
                                setValue={value => {
                                    if (!value || parseInt(value) < 32) {
                                        setInfo(prev => {
                                            return {
                                                ...prev,
                                                fixedFeeRate: value
                                            }
                                        })
                                    }
                                }}/>
                            <RaikoDatePicker
                                label={"تاریخ شروع فعالیت"}
                                date={info.activityStartDate}
                                setDate={value => {
                                    setInfo(prev => {
                                        return {
                                            ...prev,
                                            activityStartDate: value
                                        }
                                    })
                                }}
                            />
                            <RaikoMoneyInputOutlined
                                labelText={"حداقل مبلغ واریز پس انداز (ریال)"}
                                value={info.minimumAmountReceivedPerMonth}
                                setValue={value => {
                                    setInfo(prev => {
                                        return {
                                            ...prev,
                                            minimumAmountReceivedPerMonth: value
                                        }
                                    })
                                }}
                            />
                            <RaikoNumberInputOutlined
                                labelText={"تاریخ آخرین روز مجاز واریز"}
                                value={info.theLastDayAllowedToReceiveSavingsPerMonth}
                                setValue={value => {
                                    if (!value || parseInt(value) < 32) {
                                        setInfo(prev => {
                                            return {
                                                ...prev,
                                                theLastDayAllowedToReceiveSavingsPerMonth: value
                                            }
                                        })
                                    }
                                }}/>
                            <RaikoToggleOutlined
                                checked={info.enabled}
                                setChecked={state => {
                                    setInfo(prev => {
                                        return {
                                            ...prev,
                                            enabled: state
                                        }
                                    })
                                }}
                                labelText={"وضعیت"}
                            />
                        </RaikoGridThreeColumn>
                        <RaikoSimpleMultiLineInputOutlined
                            labelText={"آدرس"}
                            value={info.postalAddress}
                            setValue={value => {
                                setInfo(prev => {
                                    return {
                                        ...prev,
                                        postalAddress: value
                                    }
                                })
                            }}/>
                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoBaseCardContainer>


            <RaikoBaseCardContainer>
                <RaikoCreatorInfo createdBy={info.createdBy} createdAt={info.createdAt}/>
            </RaikoBaseCardContainer>

        </RaikoGridOneColumn>
    )
}
